import type { OrderStatus } from '../types/api/order'

export const OPEN_ORDER_STATUSES: OrderStatus[] = [
    'draft',
    'awaitingApproval',
    'confirmed',
    'inProduction',
    'partiallyShipped',
]
